import React from "react";
export default class PeopleDocumentTitle extends React.Component {
    constructor(props) {
        super(props);       
        let self = this;
        this.titleRef = null;
        this.setTitleRef = element => {
            self.titleRef = element;
        }
        this.state = {
            hasOverflowText:false,
            overflowCollapsed:true
        }        
        this.toggleShowMore = this.toggleShowMore.bind(this);
        this.isTitleOverflow = this.isTitleOverflow.bind(this);
    }

    componentDidMount(){
        let self = this;
        this.setState({hasOverflowText:self.isTitleOverflow()});
    }

    toggleShowMore(){
        this.setState({overflowCollapsed:!this.state.overflowCollapsed});
    }

    isTitleOverflow(){      
        return this.titleRef.offsetWidth < this.titleRef.scrollWidth; 
    }

    render(){
        let self = this;
        return (
            <>
                <div ref={this.setTitleRef} className={`ap-people-document-title ${!self.state.hasOverflowText || self.state.overflowCollapsed ? "ap-people-document-title-overflow" :""} `}>{this.props.title}</div>  
                {self.props.title && self.state.hasOverflowText ? 
                (<p onClick={()=>self.toggleShowMore()} className="ap-clickable ap-people-documents-expander">{self.state.overflowCollapsed ? "Show more" : "Show less"}</p>) 
                : ""}
            </>
        );
    }
}